import { render, staticRenderFns } from "./itemReleaseTypeManageList.vue?vue&type=template&id=aa16fdf4&scoped=true"
import script from "./itemReleaseTypeManageList.vue?vue&type=script&lang=js"
export * from "./itemReleaseTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseTypeManageList.vue?vue&type=style&index=0&id=aa16fdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa16fdf4",
  null
  
)

export default component.exports